module.exports = __webpack_public_path__ + "img/template-wire-2.7feb0aca.jpg";